import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const DEFAULT_LABELS = {
  login: 'Login',
  signup: 'Sign Up',
  pricing: 'Pricing',
  contact: 'Contact',
  blog: 'Blog',
  calculator: 'Calculator',
  community: 'Community',
  dashboard: 'Dashboard',
  inventory: 'Inventory',
  recipes: 'Recipes',
  batches: 'Batches',
  calendar: 'Calendar',
  notifications: 'Notifications',
  generator: 'Generator',
  print: 'Print Center',
  sales: 'Sales Dashboard',
  labels: 'Label Generator',
  backup: 'Data Backup',
  reports: 'Usage Reports',
  notes: 'Lab Notes',
  quickbatch: 'Quick Batch',
  admin: 'Admin'
};

function toTitle(segment) {
  if (!segment) return '';
  return segment
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export default function Breadcrumbs({ labels = {}, items = null }) {
  const { pathname } = useLocation();
  const segments = pathname.split('/').filter(Boolean);
  const mergedLabels = { ...DEFAULT_LABELS, ...labels };
  const resolvedItems = Array.isArray(items)
    ? items
    : [
        { label: 'Home', to: '/' },
        ...segments.map((segment, index) => {
          const to = '/' + segments.slice(0, index + 1).join('/');
          return { label: mergedLabels[segment] || toTitle(segment), to };
        })
      ];

  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      <ol>
        {resolvedItems.map((item, index) => {
          const isLast = index === resolvedItems.length - 1;

          return (
            <li key={`${item.label}-${index}`} aria-current={isLast ? 'page' : undefined}>
              {isLast || !item.to ? (
                <span className="currentcrumb">{item.label}</span>
              ) : (
                <Link to={item.to}>{item.label}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
